import type {
	CustomField,
	CustomFieldType,
	CustomFieldCollectionType,
	CustomFieldSystemType,
} from '@helpcenter/forge-ui-utils';
import type { FieldType } from 'state/persisted/request-create/types';

interface UserIn {
	accountId: string;
}

const fieldMap: Record<
	CustomFieldCollectionType,
	Partial<Record<CustomFieldSystemType, FieldType>>
> = {
	none: {
		string: 'text',
		number: 'text',
		object: 'textarea',
		user: 'userpicker',
		datetime: 'datetime',
		date: 'date',
	},
	list: {
		string: 'labelpicker',
		user: 'multiuserpicker',
	},
};

export const getMappedFieldType = (extension: CustomField | CustomFieldType): FieldType => {
	const collection: CustomFieldCollectionType =
		extension.properties.collection === 'list' ? 'list' : 'none';
	return fieldMap[collection][extension.properties.type] || 'unknown';
};

export const transformValue = (
	value: unknown,
	extension: CustomField | CustomFieldType,
): unknown => {
	switch (extension.properties.type) {
		case 'object':
			return value != null ? JSON.stringify(value) : value;
		case 'user':
			return value != null ? transformUser(value as UserIn | UserIn[]) : value;
		default:
			return value;
	}
};

const transformUser = (value: UserIn | UserIn[]): string | string[] =>
	Array.isArray(value) ? value.map((user) => user.accountId).join(',') : value.accountId;
